import styled from 'styled-components';

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin:15px 0;
`;

export const Label = styled.div`
    background-color: #E4E4E7;
    padding: 5px 15px;
    border-radius: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    width: fit-content;
`;

export const Address = styled.p`
    font-size: 12px;
    line-height: 1.7; 
    font-weight: 400;
    color: #1C1C1C; 
`;

export const Banner = styled.img`
    width: 100%;
    height: 300px;
    border-radius: 15px;
    overflow: hidden;
    object-fit: cover;
    box-sizing: border-box;
`;

export const Title = styled.h2`
    font-size: 16px;
    line-height: 1.4;
    font-weight: 500;
    color: #3F3F46;
    margin: 10px 0;
`;

export const Description = styled.p`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 400;
  color: #52525B;
  margin-bottom:15px;
  padding:10px;
`;

export const WebsiteContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px;
    border-radius: 10px;
    background-color: #F4F4F5;
`;

export const WebsiteTitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    background-color: #FFF;
    border-radius: 10px;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
`;

export const WebsiteUrlContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 20px;
    background-color: #FFF;
    border-radius: 10px;
    align-items: center;
    justify-content: center;
`;

export const DiscountContainer = styled.div`
    display: flex;
    background-color: #FFF;
    border-radius: 20px;
    padding: 20px;
    gap: 20px;
    border: 2px solid #F4F4F5;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
`;

export const DiscountCode = styled.div`
    width: 100px;
    height: 100px;
    border-radius: 10px;
    border: 2px solid rgba(248, 179, 209, 0.45);
    overflow: 'hidden';
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    align-self: flex-start;
`;

export const DiscountLabelValue = styled.h2`
  font-size: 22px;
  line-height: 1.7;
  font-weight: 600;
  color: #3F3F46;
  text-align: center;
  margin-top: auto;
`;

export const DiscountLabel = styled.div`
    margin-top: auto;
    text-align: center;
    font-size: 16px;
    line-height: 1.7; 
    font-weight: 400;
    width: 100%;
    border-radius: 0 0 8px 8px;
    background-color: rgba(248, 179, 209, 0.45);
`;

export const DiscountTextContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 12px;
    flex: 1;
    min-width: 250px;
`;

export const DiscountTitleValue = styled.h2`
  font-size: 16px;
  line-height: 1.7;
  font-weight: 600;
  color: #3F3F46;
  margin-top: auto;
`;

export const DiscountCodeContainer = styled.div`
    background-color: #FFF;
    border-radius: 35px;
    border: 2px dashed rgba(154, 228, 101, 0.39);
    height: 50px;
    min-width: 150px;
    display: flex;
    padding: 0 20px;
    justify-content: center;
    align-items: center;
`;

export const DiscountCodeValue = styled.span`
  font-size: 16px;
  line-height: 1.7;
  font-weight: 600;
  color: #1c1c1c;
`;

export const GalleryItem = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 10px;
    overflow: hidden;
    object-fit: cover;
    box-sizing: border-box;
`;

export const MapContainer = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    padding: 10px;
    border-radius: 15px;
    background-color: #F4F4F5;
    height: 500px;
`;

export const Button = styled.a`
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px; 
    background-color: #1c1c1c;
    border-radius: 25px;
`;

export const LocationButton = styled.a`
    position: absolute;
    bottom: 20px;
    left: calc(50% - 100px);
    right: calc(50% - 100px);
    width: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px; 
    background-color: #1c1c1c;
    border-radius: 25px;
`;

export const ButtonText = styled.span`
  font-size: 16px;
  line-height: 1.7;
  font-weight: 600;
  color: #FFF;
`;
